import React from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";

const styles = `
  .access-check-overlay {
    position: fixed;
    inset: 0;
    background: linear-gradient(135deg, #004263 0%, #42b0d5 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    color: white;
    font-family: "Maersk Text", Arial, sans-serif;
  }

  .access-check-card {
    background: rgba(255, 255, 255, 0.96);
    border-radius: 20px;
    box-shadow: 0 16px 40px rgba(0, 66, 99, 0.28);
    padding: clamp(2.5rem, 6vw, 4rem);
    max-width: 480px;
    width: 90%;
    text-align: center;
  }

  .loader-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 auto 2rem;
  }

  .spinner {
    width: 100%;
    height: 100%;
    border: 6px solid rgba(66, 176, 213, 0.2);
    border-top: 6px solid #42b0d5;
    border-radius: 50%;
    animation: spin 1.2s linear infinite;
  }

  .icon-pulse {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 3.5rem;
    color: #004263;
    animation: pulse 2s ease-in-out infinite;
  }

  .check-title {
    font-size: clamp(1.9rem, 5vw, 2.8rem);
    font-weight: 700;
    margin-bottom: 1rem;
    color: #004263;
  }

  .check-message {
    font-size: clamp(1.1rem, 3vw, 1.35rem);
    line-height: 1.5;
    color: #004263;
    opacity: 0.9;
    margin-bottom: 1.5rem;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes pulse {
    0%, 100% { opacity: 0.6; transform: translate(-50%, -50%) scale(1); }
    50% { opacity: 1; transform: translate(-50%, -50%) scale(1.15); }
  }
`;

const STYLE_ID = "access-check-loader-dtr";

if (
  typeof window !== "undefined" &&
  !document.head.querySelector(`style[data-style-id="${STYLE_ID}"]`)
) {
  const style = document.createElement("style");
  style.setAttribute("data-style-id", STYLE_ID);
  style.textContent = styles;
  document.head.appendChild(style);
}

const AccessCheckLoader = () => (
  <div className="access-check-overlay">
    <div className="access-check-card">
      <div className="loader-container">
        <div className="spinner" />
      </div>
      <h1 className="check-title">Checking Access Rights</h1>
      <p className="check-message">
        Verifying your permissions.
        <br />
        This will only take a moment...
      </p>
      <p style={{ color: "#004263", opacity: 0.75 }}>
        Powered by GDA | IONIS
      </p>
    </div>
  </div>
);

export default AccessCheckLoader;
